// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.microphone[data-v-0165cfcd] {
  max-width: 540px;
  padding-top: 12px;
  padding-bottom: 12px;
}
.microphone .microphone-header[data-v-0165cfcd] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 15px;
}
.microphone .microphone-header span[data-v-0165cfcd] {
  font-size: 16px;
  font-weight: 600;
  width: 58%;
}
.microphone .microphone-header .custom-select-wrapper[data-v-0165cfcd] {
  max-width: 300px;
}
.microphone .linkBtn[data-v-0165cfcd] {
  color: var(--base-blue-color2);
  cursor: pointer;
}
.microphone .microphone-level[data-v-0165cfcd] {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  margin-bottom: -1px;
}
.microphone .microphone-level-check[data-v-0165cfcd] {
  display: flex;
  justify-content: flex-end;
  padding: 4px 15px 4px;
}
.microphone .microphone-visualizer[data-v-0165cfcd] {
  display: flex;
  justify-content: space-between;
  padding-left: 2px;
}
.microphone .microphone-visualizer .microphone-visualizer-elem[data-v-0165cfcd] {
  margin-right: 5px;
  height: 10px;
  width: 25px;
  background-color: var(--progress-bg);
  border-radius: 10px;
}
.microphone .microphone-visualizer .microphone-visualizer-elem .microphone-visualizer-elem-active[data-v-0165cfcd] {
  height: 100%;
  width: 100%;
  background-color: #4DD965;
  border-radius: 10px;
}
.microphone .microphone-range-slider[data-v-0165cfcd] {
  justify-content: center;
  flex: 1 1 10px;
  display: flex;
  height: 54px;
}
.microphone .microphone-range-slider > *[data-v-0165cfcd] {
  margin: auto 0;
}
.microphone .microphone-range-slider i[data-v-0165cfcd] {
  font-size: 16px;
  color: #aaa;
}
.microphone .microphone-range-slider .slider[data-v-0165cfcd] {
  flex: 1;
  margin: auto 12px;
}
.microphone .microphone-range-slider[data-v-0165cfcd] range-slider {
  display: inline-block;
  padding: 0 10px;
  height: 5px;
  width: 130px;
}
.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider.disabled {
  opacity: 0.5;
}
.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-inner {
  display: inline-block;
  position: relative;
  height: 100%;
  width: 100%;
}
.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-rail,
.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-fill {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  height: 2px;
  border-radius: 5px;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-rail {
  width: 100%;
  background-color: #e2e2e2;
}
.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-fill {
  background-color: var(--base-blue-color2);
}
.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-knob {
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: #aaa;
  -webkit-box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-hidden {
  display: none;
}
.microphone[data-v-0165cfcd] .mic-select .selected {
  overflow: hidden;
}
.microphone .media-settings-column-1[data-v-0165cfcd] {
  margin-right: auto;
}
.microphone .media-settings-column-2[data-v-0165cfcd] {
  width: 300px;
  max-width: 300px;
  display: flex;
  flex-direction: row;
}
@media (max-width: 600px) {
.microphone .media-settings-column-2[data-v-0165cfcd] {
    width: 200px;
    max-width: 200px;
}
.microphone .microphone-visualizer .microphone-visualizer-elem[data-v-0165cfcd] {
    height: 8px;
    width: calc(200px / 10 - 5px);
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/settings/MicrophonesSettings.vue"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;EAC9C,sCAAsC;EACtC,wCAAwC;EACxC,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,6BAA6B;AACjC;AACA","sourcesContent":[".microphone[data-v-0165cfcd] {\n  max-width: 540px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.microphone .microphone-header[data-v-0165cfcd] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 3px 15px;\n}\n.microphone .microphone-header span[data-v-0165cfcd] {\n  font-size: 16px;\n  font-weight: 600;\n  width: 58%;\n}\n.microphone .microphone-header .custom-select-wrapper[data-v-0165cfcd] {\n  max-width: 300px;\n}\n.microphone .linkBtn[data-v-0165cfcd] {\n  color: var(--base-blue-color2);\n  cursor: pointer;\n}\n.microphone .microphone-level[data-v-0165cfcd] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 15px;\n  margin-bottom: -1px;\n}\n.microphone .microphone-level-check[data-v-0165cfcd] {\n  display: flex;\n  justify-content: flex-end;\n  padding: 4px 15px 4px;\n}\n.microphone .microphone-visualizer[data-v-0165cfcd] {\n  display: flex;\n  justify-content: space-between;\n  padding-left: 2px;\n}\n.microphone .microphone-visualizer .microphone-visualizer-elem[data-v-0165cfcd] {\n  margin-right: 5px;\n  height: 10px;\n  width: 25px;\n  background-color: var(--progress-bg);\n  border-radius: 10px;\n}\n.microphone .microphone-visualizer .microphone-visualizer-elem .microphone-visualizer-elem-active[data-v-0165cfcd] {\n  height: 100%;\n  width: 100%;\n  background-color: #4DD965;\n  border-radius: 10px;\n}\n.microphone .microphone-range-slider[data-v-0165cfcd] {\n  justify-content: center;\n  flex: 1 1 10px;\n  display: flex;\n  height: 54px;\n}\n.microphone .microphone-range-slider > *[data-v-0165cfcd] {\n  margin: auto 0;\n}\n.microphone .microphone-range-slider i[data-v-0165cfcd] {\n  font-size: 16px;\n  color: #aaa;\n}\n.microphone .microphone-range-slider .slider[data-v-0165cfcd] {\n  flex: 1;\n  margin: auto 12px;\n}\n.microphone .microphone-range-slider[data-v-0165cfcd] range-slider {\n  display: inline-block;\n  padding: 0 10px;\n  height: 5px;\n  width: 130px;\n}\n.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider.disabled {\n  opacity: 0.5;\n}\n.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-inner {\n  display: inline-block;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-rail,\n.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-fill {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  height: 2px;\n  border-radius: 5px;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-rail {\n  width: 100%;\n  background-color: #e2e2e2;\n}\n.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-fill {\n  background-color: var(--base-blue-color2);\n}\n.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-knob {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  background-color: #aaa;\n  -webkit-box-shadow: 1px 1px rgba(0, 0, 0, 0.2);\n  box-shadow: 1px 1px rgba(0, 0, 0, 0.2);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.microphone .microphone-range-slider[data-v-0165cfcd] .range-slider-hidden {\n  display: none;\n}\n.microphone[data-v-0165cfcd] .mic-select .selected {\n  overflow: hidden;\n}\n.microphone .media-settings-column-1[data-v-0165cfcd] {\n  margin-right: auto;\n}\n.microphone .media-settings-column-2[data-v-0165cfcd] {\n  width: 300px;\n  max-width: 300px;\n  display: flex;\n  flex-direction: row;\n}\n@media (max-width: 600px) {\n.microphone .media-settings-column-2[data-v-0165cfcd] {\n    width: 200px;\n    max-width: 200px;\n}\n.microphone .microphone-visualizer .microphone-visualizer-elem[data-v-0165cfcd] {\n    height: 8px;\n    width: calc(200px / 10 - 5px);\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
